
import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

export const CharterSignatureCounter = () => {
  const [count, setCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchSignaturesCount = async () => {
      try {
        const {
          count: signaturesCount,
          error
        } = await supabase.from("charter_signatories").select("*", {
          count: "exact",
          head: true
        });

        if (error) {
          console.error("Error fetching signatures count:", error);
          return;
        }

        setCount(signaturesCount || 0);
      } catch (error) {
        console.error("Error in fetchSignaturesCount:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSignaturesCount();

    // Écouter les nouvelles signatures en temps réel
    const channel = supabase.channel("public:charter_signatories").on("postgres_changes", {
      event: "INSERT",
      schema: "public",
      table: "charter_signatories"
    }, () => {
      // Incrémenter le compteur à chaque nouvelle signature
      setCount(prevCount => prevCount + 1);
    }).subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  return (
    <div className="flex items-center justify-center my-8">
      <div className="flex flex-col items-center justify-center gap-1 px-6 py-4 bg-[#33C3F0] rounded-xl shadow-lg max-w-xs">
        <div className="flex items-center gap-2">
          <Users className="h-6 w-6 text-white" />
          <span className="text-white text-xl font-medium">Nombre de signataires</span>
        </div>
        <div className="text-white text-xl">de la charte</div>
        {loading ? (
          <div className="text-white text-xl font-semibold">Chargement...</div>
        ) : (
          <div className="text-white text-3xl font-bold mt-1">
            {count.toLocaleString('fr-FR')}
          </div>
        )}
      </div>
    </div>
  );
};
